import { render, staticRenderFns } from "./OAuth2Redirect.vue?vue&type=template&id=5a568a33"
import script from "./OAuth2Redirect.vue?vue&type=script&lang=js"
export * from "./OAuth2Redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports